import script from "./CableTemperature.vue?vue&type=script&setup=true&lang=ts"
export * from "./CableTemperature.vue?vue&type=script&setup=true&lang=ts"

import "./CableTemperature.vue?vue&type=style&index=0&id=59f28f8a&lang=css"

const __exports__ = script;

export default __exports__